import { AlertCircle, Check, Info } from "lucide-react"

import { cn } from "@/lib/utils"

// The auth screens' banner (design/spec/auth/auth.html `.alert`): bad for a
// refused sign in or reset, good for a confirmation, quiet for a hint. The
// design's teal success hue has no token in the theme, so `good` reads the
// status green (`--done`), the app's one success colour.
const TONES = {
  bad: {
    Icon: AlertCircle,
    className: "border-primary/30 bg-[var(--red-soft)] text-foreground [&>svg]:text-primary",
  },
  good: {
    Icon: Check,
    className: "border-done/30 bg-done/10 text-foreground [&>svg]:text-done",
  },
  quiet: {
    Icon: Info,
    className: "border-border bg-secondary text-muted-foreground [&>svg]:text-ink-3",
  },
}

export default function AuthAlert({ tone = "quiet", className, children }) {
  const { Icon, className: toneClass } = TONES[tone] ?? TONES.quiet

  return (
    <div
      role={tone === "bad" ? "alert" : "status"}
      className={cn(
        "flex items-start gap-[11px] rounded-[12px] border px-[14px] py-3 text-[13px] leading-[1.5] [&_a]:font-semibold [&_a]:underline [&_a]:underline-offset-2 [&_b]:font-bold",
        toneClass,
        className
      )}
    >
      <Icon className="mt-[1px] size-[17px] shrink-0" strokeWidth={2} />
      <div>{children}</div>
    </div>
  )
}
